import { Box, type BoxProps } from '@chakra-ui/react';
import * as React from 'react';

// Exported because page-header components (e.g. the app's ViewHeading)
// render their own max-width wrapper above this one's page content — both
// must match or the header and body misalign horizontally.
export const PAGE_CONTENT_PX = { base: 4, md: 6, lg: 6 };
export const PAGE_MAX_WIDTH = '1600px';

type MaxWidthContainerProps = BoxProps & {
    children?: React.ReactNode;
};

export const MaxWidthContainer = React.forwardRef<
    HTMLDivElement,
    MaxWidthContainerProps
>(({ children, ...rest }, ref) => {
    return (
        <Box px={PAGE_CONTENT_PX} ref={ref} {...rest}>
            <Box maxW={PAGE_MAX_WIDTH} margin='auto'>
                {children}
            </Box>
        </Box>
    );
});
